module.exports = __webpack_public_path__ + "img/agreement-button-bg.837aecbd.png";